import { TransferMethod } from "../../core/models/entities/LogoOptions";

const SCREEN_PRINT = "screen print";

export const isScreenPrintMethod = (m: TransferMethod): boolean =>
  m.displayName.toLowerCase().includes(SCREEN_PRINT) ||
  m.type.toLowerCase().includes(SCREEN_PRINT);

/**
 * Filters methods users must not be able to PICK in the frontend:
 * - screen-print methods (hardcoded rule — only created via NAV import)
 * - methods on the admin-managed blocklist (Metoder page), matched
 *   case-insensitively on method key
 * Never removes the currently selected method, so an existing/cloned logo
 * whose method is later blocked keeps displaying it.
 */
export const excludeNonSelectableMethods = (
  methods: TransferMethod[],
  selectedKey?: string | null,
  blockedKeys?: readonly string[] | null
): TransferMethod[] => {
  const blocked = new Set((blockedKeys ?? []).map((k) => k.toLowerCase()));
  return methods.filter(
    (m) =>
      m.key === selectedKey ||
      (!isScreenPrintMethod(m) && !blocked.has(m.key.toLowerCase()))
  );
};

/** @deprecated use excludeNonSelectableMethods (also applies the admin blocklist) */
export const excludeScreenPrintMethods = (
  methods: TransferMethod[],
  selectedKey?: string | null
): TransferMethod[] => excludeNonSelectableMethods(methods, selectedKey);
